import { render, staticRenderFns } from "./SiteLogsNotifications.vue?vue&type=template&id=85cb1e90&scoped=true"
import script from "./SiteLogsNotifications.vue?vue&type=script&lang=js"
export * from "./SiteLogsNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cb1e90",
  null
  
)

export default component.exports